import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { NewsItemFacade } from '../facades/news-item.facade';

export function newsItemCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const newsItemFacade = inject(NewsItemFacade);
        newsItemFacade.clear();

        return true;
    };
}
